import { errorMessage } from '../../../common/api/httpClient';
import { sourceSaveErrorMessage } from '../../../common/api/sourceApplicationError';
import { WorkItemSourceSaveFailure } from './workItemActionGate';

export function workItemActionErrorMessage(error: unknown): string {
  if (error instanceof WorkItemSourceSaveFailure) {
    return sourceSaveErrorMessage(error.reason);
  }
  // Core 响应继续使用原有 ApiError/traceId 表示与重试分类。
  return errorMessage(error);
}
